export const STRICT_INVOICE_PATTERN = /^[12][0-9]{3}$/;

export const deriveInvoiceGroup = (invoiceNumber) => {
  if (typeof invoiceNumber !== "string" || !STRICT_INVOICE_PATTERN.test(invoiceNumber)) {
    return null;
  }

  return invoiceNumber.startsWith("1") ? "A" : "B";
};

export const getInvoiceValidationState = (digits, invalidEntry, touched) => {
  const invoice = digits.join("");
  const groupType = deriveInvoiceGroup(invoice);
  const invoiceValid = Boolean(groupType) && !invalidEntry;
  const hasInvalidStartingDigit = Boolean(digits[0]) && !/^[12]$/.test(digits[0]);
  const hasCompletedInvalidInvoice = invoice.length === 4 && !invoiceValid;
  const showError = (
    invalidEntry
    || hasInvalidStartingDigit
    || hasCompletedInvalidInvoice
    || (touched && !invoiceValid)
  );

  return {
    invoice,
    groupType,
    invoiceValid,
    showError,
  };
};